<template>
    <g  
        ref="toolContainer"
        style="pointer-events:all"
        :data-moving="isToolMoving"
        :data-focused="isToolFocused"
        :data-selected="isToolSelected"
        :style="toolStyle" class="tool_container" 
    >      
        <g id="g_tool_bodyAndHandles">
            <component 
                :is="tool.attrib.type + 'CMP'"
                v-bind="{
                    ref       : id,
                    tool      : tool,
                    isToolFocused : isToolFocused,
                    isToolSelected : isToolSelected,
                    isToolDenteActive : isToolDenteActive,
                    isToolLocationActive : isToolLocationActive,
                    isToolLabelVisible : isToolLabelVisible,
                    isToolLocationVisible : isToolLocationVisible,
                    isToolActive : isToolActive,
                    isToolMoving : isToolMoving,
                    toolColor : toolColor,
                    fill      : toolColor,
                }"
            ></component>

            <g id="g_tool_handles">
                <circle v-for="(pt, idx) in tool.coords.pts" :key="idx"
                    v-show="showHandles"
                    @mouseover="hHover = true"
                    @mouseleave="hHover = false"
                    v-bind="{
                        id    : `${id}-h[${idx}]`,
                        cx    : pt.x, 
                        cy    : pt.y,
                        class : {
                            toolHandle : (hHover),
                            toolHandleMov : isToolMoving,
                        },
                        style : {                   
                            '--tool-handle-radius': ((hHover ? sizes.hHoverFactor : 1) * ((isToolFocused && !hHover) ? focusedSizes.handle : sizes.handle)),      
                            fill : (hHover) ? 'yellow' : hColor(tool, idx)
                        }
                    }" 
                />
            </g>
        </g>

            
        <text 
            v-show="showLabel"
            @mouseover="lHover = true"
            @mouseleave="lHover = false"            
            :filter="toolConfidence" 
            v-bind="{
                id    : id + '-label',
//                    ref : label.id,
                x : tool.label.vLabel.x,
                y : tool.label.vLabel.y,
                style : toolLabel_style
            }"
            class="tool-label"
            dominant-baseline="middle" text-anchor="middle"                
        >
            <title>{{ labelDesc }}</title>
            {{ tool.label.text + (tool.state.marked ? '*' : '') }}                
        </text>
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
    import ptoCMP       from './pto.vue';
    import retaCMP      from './reta.vue';
    import retangCMP    from './retang.vue';
    import circCMP      from './circ.vue';
    import retangIncCMP from './retangInc.vue';
    import pathCMP      from './path.vue';
    import curvCMP      from './curv.vue';

    import { nodes   } from '@/globals/nodes';
    import { gConsts } from '@/globals/gConsts';
    import { tools   } from '../../mixins/tools';
    import { evtBus  } from '@/main';

    import { mapGetters, mapState, mapActions } from 'vuex';
    import _ from 'lodash';


    // =========================================================================================

    export default {
        name : 'toolCMP',
        components: {
            ptoCMP      ,  
            retaCMP     , 
            retangCMP   ,
            circCMP     ,
            retangIncCMP,
            pathCMP     ,
            curvCMP
        },

        // -----------------------------------------------------------------

        mixins: [tools],

        // -----------------------------------------------------------------

        data () {
            return {
                sizes : {   
                    label : {
                        dist  : 30,
                        font  : 20,
                        lineW : 1
                    },
                    handle   : 5,
                    strokeW  : 1.5,
                    hStrokeW : 1,
                    hHoverFactor    : 2,
                    bodyHoverFactor : 5, 
                },
                focusedSizes: {
                    handle: 7
                },
                hHover : false,
                lHover : false,

                localLabel : {
                    vLabel : { x : 0, y : 0 },
                },

                updateLabelPosGuard: false,
            }
        },

        watch : {
            labelPos(newLabelPos, oldLabelPos) {
                if ((this.tool.label.vLabel == null) || 
                    (newLabelPos.lengthSq() != this.$Victor.fromObject(this.tool.label.vLabel).lengthSq())) {
                    // this.updateLabelPosGuard = true;
                    // console.log(this.tool.id + ' - debouncing updateTool - updating label pos', newLabelPos);
                    this.tool.label.vLabel = newLabelPos.toObject();
                    // evtBus.$emit('evt_toolAction', 'updateToolStore');
                    // this.debouncedUpdateTool({ vLabel: newLabelPos });
                }
            },
        },
        

        // -----------------------------------------------------------------

        computed: {
            ...mapState({
            }),

            // -----------------------------------------------------------------

            ...mapGetters([
                'GET_teethLETools',
                'GET_teethSegTools',
                'GET_elemsLoaded',
                // 'GET_waZoomScale',
            ]),

            // -----------------------------------------------------------------

            showTool() { 
//                 var show = this.GET_elemsLoaded && (!this.$store.state.ui.toggles.clearImgView);

//                 switch (this.layerVisibility) {
//                     case gConsts.node.tools.visibility.GLOBAL : break;  // a condicao acima já é suficiente para mostrar a tool
//                     case gConsts.node.tools.visibility.LAYER  : show = (show && this.isToolLayerActive); break;
//                     case gConsts.node.tools.visibility.LABEL  : show = (show && this.isToolLabelActive); break;
//                     case gConsts.node.tools.visibility.NONE   : show = false;
//                 }

// //                ( (this.isToolLayerActive && this.isToolLabelActive) || this.isLocationTool );

//                 return show;
                return true;
            },

            // -----------------------------------------------------------------

            layerVisibility() {
                return nodes.getNode(this.tool.label.layer)?.tools.visibility ?? gConsts.node.tools.visibility.NONE;
            },

            // -----------------------------------------------------------------

            showLabel() { 
                if (this.localState.isToolLayerActive && this.isToolActive)
                    return true;
                if (this.isToolActiveLayerLocation)
                    return true;
                if (this.isToolLabelVisible && this.localState.showLocationTool)
                    return true;
                if (this.isProbableToothTool)
                    return true;
                return false;
            },

            // -----------------------------------------------------------------

            showHandles () {
                if (this.isToolFocused || this.isToolSelected)
                    return true;
                return !this.$store.state.ui.toggles.showToolHandles && this.isToolActive && 
                       this.localState.isToolLayerActive             && 
                       (this.tool.state.input != gConsts.tool.state.inputs.BOT);
            },

            // -----------------------------------------------------------------

            toolVisualState() {
            //    console.log('[toolCMP][toolVisualState] - ' + this.tool.id + ' - [' + this.tool.id + ']');

                // Deep dependency logging for reactivity cascade debugging
                // Only log for a specific tool (e.g., lb_dente48) to avoid flooding
                const toolId = this.$toolId || this.tool?.id || this.tool?.label?.id;
                /*
                if (this.tool && this.tool.label && this.tool.label.id === 'lb_dente48') {
                    // Log all dependencies accessed by toolVisualState
                    // WARNING: Logging computed properties and Vuex getters here can cause recursion!
                    // Commented out to prevent stack overflow.
                    // console.log('[toolCMP][toolVisualState] deps', {
                    //     $toolId: toolId,
                    //     isToolActive: this.isToolActive,
                    //     isToolDenteActive: this.isToolDenteActive,
                    //     isToolActiveLabelLocation: this.isToolActiveLabelLocation,
                    //     isToothSegTool: this.isToothSegTool,
                    //     isToolActiveLayerLocation: this.isToolActiveLayerLocation,
                    //     localState: JSON.parse(JSON.stringify(this.localState)),
                    //     tool: this.tool,
                    //     toolLabelId: this.tool.label.id,
                    //     toolLabelLayer: this.tool.label.layer,
                    //     labelNode: this.labelNode,
                    //     // Vuex Getters (if still used):
                    //     // GET_activeLabel: this.GET_activeLabel,
                    //     // GET_activeDente: this.GET_activeDente,
                    // });
                }
                */
                var layerOrGlobalVisibility, toolEdit_movTypes, layerCurrentFunction,
                    visualState = gConsts.tool.state.visual.ANNOT_HIDDEN,
                    layerNode = nodes.getNode(this.tool.label.layer);
                    
                    layerCurrentFunction = (layerNode.layerTools.pFunction == gConsts.node.layerTools.pFunctions.ANNOTATION) 
                        ? layerNode.layerTools.pFunction
                        : ((this.localState.isToolLayerActive || this.isToolLabelVisible)
                            ? gConsts.node.layerTools.pFunctions.ANNOTATION 
                            : gConsts.node.layerTools.pFunctions.LOCATION);  // location layer are considered annotation layers when active

                    layerOrGlobalVisibility = [gConsts.node.layerTools.visibility.LAYER, 
                                               gConsts.node.layerTools.visibility.GLOBAL].includes(layerNode.layerTools.visibility);                    
                    toolEdit_movTypes = [gConsts.mov.types.TOOL_CREATION,
                                         gConsts.mov.types.TOOL_DRAG    ,
                                         gConsts.mov.types.HANDLE_DRAG  ,
                                         gConsts.mov.types.HANDLES_PUSH ,
                                         gConsts.mov.types.HANDLES_DEL  ,
                                         gConsts.mov.types.LABEL_DRAG];

                switch (layerCurrentFunction) {
                    case gConsts.node.layerTools.pFunctions.ANNOTATION :
                        visualState = this.isToolActive
                            ? !this.isToolMoving
                                ? gConsts.tool.state.visual.ANNOT_EDIT                  // isToolActive && isToolMoving
                                : gConsts.tool.state.visual.ANNOT_ACTIVE                // isToolActive && !isToolMoving                                
                            : (this.localState.isToolLabelActive || this.isToolLabelVisible)
                                ? gConsts.tool.state.visual.ANNOT_INACTIVE_ACTIVELABEL  // !isToolActive && isToolLabelActive
                                : layerOrGlobalVisibility
                                    ? gConsts.tool.state.visual.ANNOT_INACTIVE          // !isToolActive && !isToolLabelActive && layerOrGlobalVisibility 
                                    : visualState;
                        break;
                    
                    case gConsts.node.layerTools.pFunctions.LOCATION :
                        visualState = (this.isToolDenteActive || this.isToolLocationActive)
                            ? this.isToothSegTool
                                ? gConsts.tool.state.visual.LOCATION_ACTIVE_TOOTH  // isToolDenteActive && isToothSeg
                                : gConsts.tool.state.visual.LOCATION_ACTIVE_OTHER  // isToolDenteActive && !isToothSeg
                            : (this.localState.showLocationTool || this.isToolLocationVisible)            
                                ? gConsts.tool.state.visual.LOCATION_INACTIVE   // !isToolDenteActive && this.localState.showLocationTool
                                : gConsts.tool.state.visual.LOCATION_HIDDEN;    // !isToolDenteActive && !this.localState.showLocationTool
                        break;
                } 

                if (this.tool.label.id == 'lb_dente11') {
//                     console.log(`tool.label.id: ${this.tool.label.id}, tool.id: ${this.tool.id}, tool.label.layer: ${this.tool.label.layer}
// isToolDenteActive: ${this.GET_activeDente?.label.id}
// layerCurrentType: ${layerCurrentType}
//     isToolLabelActive: ${this.isToolLabelActive}
//         isToolActive: ${this.isToolActive}
//             isToolMoving: ${this.isToolMoving}
//         layerOrGlobalVisibility: ${layerOrGlobalVisibility}

//     isToolDenteActive: ${this.isToolDenteActive}
//         activeLabel: ${this.activeLabel}
//             isToolActiveLabelLocation: ${this.isToolActiveLabelLocation}

// visualState: ${visualState}`);
                }


            //    console.log(`${this.tool.label.id} : ${visualState} ${this.localState.showLocationTool}`)
                return visualState;
            },

            // -----------------------------------------------------------------

            toolStyle() {
                var strokeWidth, opacity, fillOpacity, 
                    display = 'inline';

                switch (this.toolVisualState) {
                    case gConsts.tool.state.visual.ANNOT_HIDDEN    : 
                        display = 'none'
                        break;

                    case gConsts.tool.state.visual.LOCATION_HIDDEN :
                        opacity = 0;
                        break;

                    case gConsts.tool.state.visual.ANNOT_INACTIVE : 
                        strokeWidth = 0.5;
                        opacity     = 1;
                        fillOpacity = 0.05;
                        break;

                    case gConsts.tool.state.visual.ANNOT_INACTIVE_ACTIVELABEL :

                        strokeWidth = 2.5;
                        if (!this.localState.isToolLabelActive && this.isToolLabelVisible) {
                            opacity     = 0.4;
                            fillOpacity = 0.15;
                        } else {
                            opacity     = 0.8;
                            fillOpacity = 0.15;
                        }
                        break;
                        
                    case gConsts.tool.state.visual.ANNOT_ACTIVE : 
                        strokeWidth = 3;
                        opacity     = 1;
                        fillOpacity = 0.6;
                        break;

                    case gConsts.tool.state.visual.ANNOT_EDIT : 
                        strokeWidth = 4;
                        opacity     = 0.5;
                        fillOpacity = 0.5;
                        break;

                    case gConsts.tool.state.visual.LOCATIONS :
                        opacity = 0;
                        fillOpacity = 1;
                        break;

                    case gConsts.tool.state.visual.LOCATION : 
                        strokeWidth = 1;
                        opacity     = 0.2;
                        fillOpacity = 1;
                        break;       
                        
                    case gConsts.tool.state.visual.LOCATION_ACTIVE_OTHER : 
                    case gConsts.tool.state.visual.LOCATION_INACTIVE     :
                        // strokeWidth = 2;
                        if (!(this.isToolDenteActive || this.isToolLocationActive) && this.isToolLocationVisible) {
                            opacity = 0.5;
                            fillOpacity = 0.15;
                        } else if (this.isToolLocationVisible && !this.isToothLETool) {
                            opacity = 1;
                            fillOpacity = 0.1;
                        } else {
                            opacity = this.isToothLETool ? 0.05 : 0.4;
                            fillOpacity = 0.1;
                        }
                        break;

                    case gConsts.tool.state.visual.LOCATION_ACTIVE_TOOTH : 
                        strokeWidth = 2;
                        opacity     = 0.4;
                        fillOpacity = 0.05;
                        break;       
                }

                if (this.isPathTool) {
                    fillOpacity = this.closedPath ? fillOpacity : 0;
                }
                        
                if (this.isInternalLocationTool || this.isProbableToothTool) {
                    fillOpacity = 0.2;
                    opacity = 0;
                }

                // if ( (this.tool.label.id == 'lb_dente11'                                ) || 
                //      (![gConsts.tool.state.visual.ANNOT_HIDDEN, 
                //         gConsts.tool.state.visual.LOCATION_HIDDEN].includes(this.toolVisualState)) ){
                // if (this.tool.label.id == 'lb_dente11') {
                //     console.log(`display: ${display}`);
                // }

                return {
                    display     : display,
                    '--strokeWidth' : strokeWidth, 
                    opacity     : opacity,                    
                    stroke      : this.toolColor,
                    fill        : this.toolColor,
                    fillOpacity : fillOpacity,
                }
            },

            // -----------------------------------------------------------------

            toolBody_style(){
                return {}
            },

            // -----------------------------------------------------------------

            toolHandle_style() {
                return {}
            },

            // -----------------------------------------------------------------

            toolLabel_style() {
                // var display = this.showLabel ? 'true' : 'none';

                // switch (this.toolVisualState) {
                //     case gConsts.tool.state.visual.INACTIVE : 
                //         if (this.isToolActiveLayerLocation) {
                //             display = 'true';
                //         }
                //         break;

                //     case gConsts.tool.state.visual.ACTIVE : 
                //     case gConsts.tool.state.visual.HOVER  : 
                //     case gConsts.tool.state.visual.MOVING : 
                //         display = 'true';
                //         break;
                // }

                return {
                    // strokeWidth : 1 / this.GET_waZoomScale,
                    // fillOpacity : 1,
                    // fontSize    : this.sizes.label.font / this.GET_waZoomScale,
                }
            },

            // -----------------------------------------------------------------

            toolColor() { 
                if (this.isInternalLocationTool) {
                    let regionType = this.tool.locations.internal?.faces?.list?.[0] ?? this.tool.locations.internal?.portions?.list?.[0] ?? 'default';
                    if (regionType == 'default') {
                        regionType = this.tool.label.id.split('_').at(-1) || 'default';
                    }
                    return gConsts.label.colors.toothInternal[regionType.toUpperCase()];
                }
                const color = this.labelNode?.layout.color ?? gConsts.label.colors.DEFAULT;
                return gConsts.ui.prettyColors[color] ?? color;
            },

            // -----------------------------------------------------------------

            toolConfidence() {
                var filter = ''

                switch (this.tool?.state.confidence) {
                    case gConsts.tool.state.confidence.DOUBT     : filter = 'url(#fDoubt)';     break;
                    case gConsts.tool.state.confidence.DIVERGENT : filter = 'url(#fDivergent)'; break;
                }

                return filter;
            },            

            // -----------------------------------------------------------------

            labelPos() {
                var dist, dir, offset, baseTool, label, labelPos, refPos, p0, p1, leMatches;

                // if (!this.showLabel)
                //     return this.$Victor.fromObject(this.tool.label.vLabel);

                // console.log('changing labelPos')

                baseTool = this.tool;
                if (this.isToolActiveLayerLocation) {
                    leMatches = this.GET_teethLETools.filter(tool => tool.label.id == this.tool.label.id);
                    if (leMatches.length > 0) {
                        baseTool = leMatches[0];
                    }
                }

                p0 = this.$Victor.fromObject(baseTool.coords.pts[0]);
                dist = this.sizes.label.dist;
                if (baseTool.coords.pts.length != 1) {
                    p1 = this.$Victor.fromObject(baseTool.coords.pts[1]);

                    if (this.$store.state.setup.config.labelPos == gConsts.tool.labelPos.ORIGIN) {
                        labelPos = p0;
                        refPos   = p1;
                    } else {
                        labelPos = p1;
                        refPos   = p0;
                    }

                    dir = labelPos.clone().subtract(refPos).normalize();
                } else {
                    labelPos = p0;
                    dir = this.$Victor(0, -1);
                }

                offset = dir.clone().multiply(this.$Victor(dist, dist));
                labelPos = labelPos.clone().add(offset);
                if (this.tool.label.vLabelOffset) {
                    labelPos = labelPos.clone().add(this.$Victor.fromObject(this.tool.label.vLabelOffset))
                }

                return labelPos;
            },

            // -----------------------------------------------------------------

            labelDesc() {
                var node  = nodes.getNode(this.tool.label.id),
                    desc  = '';
                                        
                if (node && (node.layout.caption != node.layout.label)) {
                    desc = node.layout.caption;
                }

                return desc;
            },
        },

        // -----------------------------------------------------------------

        methods: {
            ...mapActions([
                'ACT_runtimeUpdate',
                'ACT_toolUpdate'
            ]),

            // -----------------------------------------------------------------

            hColor(tool, ptIndex) {
                var color = 'black';
                if (ptIndex == 0) {
                    color = 'white'
                } else if ((ptIndex >= 2) && (tool.attrib.imgtype == gConsts.tool.attrib.types.RETANGULO_INC)) {
                    color = 'DeepSkyBlue'
                }

                return color;
            },

            // -----------------------------------------------------------------

            // toolHover() {
            //     var newAd, toolDentes;

            //     this.hover = true;
            //     if ( (this.tool.dente !== ''                                                                           ) && 
            //          ((this.GET_activeDente == null) || (this.GET_activeDente.label.id != this.tool.dente)   ) ) {
            //         toolDentes = this.GET_teethSegTools.filter(segTool => segTool.label.id == this.tool.dente);
            //         if (toolDentes.length > 0) {
            //             newAd = toolDentes[0];
            //             this.ACT_runtimeUpdate({ active : { dente : newAd } });
            //         }
            //     }
            // },

            updateTool(props = {}) {
                // console.log(this.tool.id + ' - updateTool', props);
                this.ACT_toolUpdate({ tool_id: this.tool.id, ...props });
            },
        },

        // -----------------------------------------------------------------

        // Lifecycle hooks
        created() {
            // const originalWatch = this.$watch;
            // this.$watch = function(expOrFn, cb, options) {
            //     const watcher = originalWatch.call(this, expOrFn, (...args) => {
            //         console.log(`Property '${expOrFn}' changed:`, ...args);
            //         return cb.apply(this, args);
            //     }, options);
            //     return watcher;
            // };
        },

        // -----------------------------------------------------------------

        mounted() {
            // console.log('mounted tool', this.tool.id);
            var outerCMP, innerCMP;

            innerCMP = this.$refs[this.id];
            outerCMP = innerCMP ? innerCMP.$parent : null;
            evtBus.$emit('evt_toolCreation', this.tool, innerCMP, outerCMP);
            // Set a unique identifier for profiler logs
            // Use tool.id if available and unique, otherwise fallback to id or generate a random id
            if (!this.constructor._toolInstanceCounter) {
                this.constructor._toolInstanceCounter = 1;
            }
            const uniqueInstanceId = `${this.tool?.id || this.id || this.tool?.label?.id || this.$options.name}_${this.constructor._toolInstanceCounter++}`;
            this.$toolId = uniqueInstanceId;

            this.debouncedUpdateTool = _.debounce(this.updateTool, 500);

            // Quando cria um novo tool eu inicio com 0,0
            if (this.tool.label.vLabel.x == 0 && this.tool.label.vLabel.y == 0) {
                this.tool.label.vLabel = this.labelPos.toObject();
            }
        },

        // -----------------------------------------------------------------

        beforeUpdate() {
        //    console.log('bUp!! ' + this.tool.id);
        },

        beforeDestroy() {
            evtBus.$emit('evt_toolDestruction', this.tool.id);
        }
    }
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
    :root {
        --handleOpacity : 0.3;
        --toolColor     : #000000;
        --strokeWidth   : 1;
    }

    .tool_nSel {
        opacity : 0.7;
        stroke-width : calc(1 / var(--wa-zoom-scale, 1));
    }

    .tool_sSel {
        opacity : 1;
        stroke-width : calc(2 / var(--wa-zoom-scale, 1));
    }

    .tool_hSel {
        opacity : 1;
        stroke-width : calc(4 / var(--wa-zoom-scale, 1));
    }


    .toolHandle {
        opacity : 0.1;
        transition : opacity 0.2s ease-in;
    }

    .toolHandleMov {
        opacity : 0.1;
    }

    .toolHandle:hover {
        opacity : 0.3;
    }

    .tool-label {
        font-family: sans-serif;
        stroke-width: calc(1 / var(--wa-zoom-scale, 1));
        fill-opacity: 1;
        font-size: clamp(15px, calc(20px / var(--wa-zoom-scale, 1)), 50px);
    }

    .tool_container {
        stroke-width: max(calc(var(--strokeWidth) / var(--wa-zoom-scale, 1) * 1px), calc(var(--strokeWidth) * 1px));
        transform: translate(0px, 0px);
    }

    /* Movendo Tool */
    .tool_container[data-moving="true"] {
        transform: translate(var(--tool-move-offset-x), var(--tool-move-offset-y));
    }

    /* Tool selecionado. Ao clicar sem mover o tool, ele fica selecionado. */
    .tool_container[data-selected="true"] {
        fill-opacity: 1 !important;
    }
    .tool_container[data-selected="true"] #g_tool_handles > circle {
        opacity: 0.5 !important;
        fill: white !important;
    }

    /* Tool com foco (Popup de anotação aberto ou ao passar o mouse sobre o item de anotação no relatório) */
    .tool_container[data-focused="true"] {
        fill-opacity: 1 !important;
    }
    .tool_container[data-focused="true"] #g_tool_handles > circle {
        opacity: 1 !important;
        fill: white !important;
    }

    #g_tool_handles > circle {
        r: calc(var(--tool-handle-radius) / var(--wa-zoom-scale, 1));
    }

    
</style>./pto.vue./retangInc.vue./retang.vue./curv.vue./circ.vue